module.exports = __webpack_public_path__ + "static/img/scene3.07c194b5.jpg";